export const downloadFile = (url, onSucces) => {
  var fileName = url.split("/");
  fetch(url)
    .then((res) => {
      return res.blob();
    })
    .then((blob) => {
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement("a");
      a.href = url;
      a.download = fileName[5].split("?")[0];
      document.body.appendChild(a);
      a.click();
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 6000);
      a.remove();
    })
    .catch((err) => {
      console.error("err: ", err);
    })
    .finally(() => {
      onSucces();
    });
};
